export const TARGET_SITE_PROGRAM = Object.freeze({
  targetSiteId: 'targetSiteId',
  targetProgramId: 'targetProgramId'
});
